import { CreateEventModal } from "./CreateEventModal";

export default CreateEventModal;
